import images from "./images";

const portfolio = [
    {
        id: 1,
        image: images.portfolio1,
        title: "Mountain Hiking",
        details: {
            date: "Jan 15, 2024",
            client: "Outdoor Enthusiasts",
            category: "Adventure Tours",
            duration: "7 Days",
            location: "Rocky Mountains, Colorado",
            cost: "$1,200 per person",
            tourGuide: "John Summit"
        },
        paragraphs: [
            "Embark on an exhilarating Mountain Hiking adventure through the scenic Rocky Mountains. Perfect for both beginners and experienced hikers, this guided journey offers a perfect blend of adventure and tranquility amidst nature's grandeur.",
            "Our expert guides will lead you through diverse trails, ensuring safety and enriching the experience with insights into the landscape's flora, fauna, and geology. This immersive hike is designed to reconnect you with the wilderness while fostering personal growth and endurance."
        ],
        gallery: [
            images.portfolio1Gallery1,
            images.portfolio1Gallery2,
            images.portfolio1Gallery3,
            images.portfolio1Gallery4,
            images.portfolio1Gallery5,
            images.portfolio1Gallery6
        ],
        requirements: [
            "Basic fitness level for hiking moderate trails",
            "Learn essential hiking techniques and safety measures",
            "Understand trail navigation and basic map reading",
            "Develop basic wilderness survival awareness"
        ],
        approach: [
            "Progressive stamina building through guided hikes",
            "Adapt to varying terrains and outdoor conditions",
            "Hands-on experience with navigation tools",
            "Learn eco-friendly hiking practices"
        ],
        highlights: [
            "Breathtaking panoramic mountain views",
            "Engaging group activities fostering teamwork",
            "Skill-building in outdoor survival and navigation",
            "A rejuvenating escape from daily life into nature"
        ]
    },
    {
        id: 2,
        image: images.portfolio2,
        title: "Historical City Walks",
        details: {
            date: "March 10, 2024",
            client: "Culture Seekers",
            category: "Cultural Experiences",
            duration: "5 Days",
            location: "Florence, Italy",
            cost: "$950 per person",
            tourGuide: "Sophia Romano"
        },
        paragraphs: [
            "Dive into the rich cultural heritage with our Historical City Exploration tour in Florence, Italy. From grand cathedrals to charming cobblestone streets, this journey takes you through the heart of a city known for its art, architecture, and timeless beauty.",
            "Our expert guides will lead you through iconic landmarks, hidden alleys, and vibrant local markets, offering insights into the city’s history, art, and culinary delights. This tour is perfect for those who wish to experience history come alive while enjoying authentic local experiences."
        ],
        gallery: [
            images.portfolio2Gallery1,
            images.portfolio2Gallery2,
            images.portfolio2Gallery3,
            images.portfolio2Gallery4,
            images.portfolio2Gallery5,
            images.portfolio2Gallery6
        ],
        requirements: [
            "Comfortable walking shoes for city exploration",
            "Interest in art, history, and cultural landmarks",
            "Basic knowledge of local etiquette and customs",
            "Willingness to immerse in guided cultural activities"
        ],
        approach: [
            "Guided walking tours of historical sites and museums",
            "Interactive storytelling to connect with the city's past",
            "Opportunities to engage with local artisans and markets",
            "Balanced itinerary with free time for personal discovery"
        ],
        highlights: [
            "Visit world-renowned landmarks like the Florence Cathedral and Uffizi Gallery",
            "Experience authentic Italian cuisine through curated food tastings",
            "Capture stunning architecture and artistic masterpieces",
            "Gain deep cultural insights from experienced local guides"
        ]
    },
    {
        id: 3,
        image: images.portfolio3,
        title: "Desert Safari Adventure",
        details: {
            date: "April 20, 2024",
            client: "Adventure Enthusiasts",
            category: "Adventure Tours",
            duration: "2 Days / 1 Night",
            location: "Dubai Desert, UAE",
            cost: "$450 per person",
            tourGuide: "Omar Al-Fahim"
        },
        paragraphs: [
            "Experience the thrill of a Desert Safari Adventure amidst the vast golden dunes of Dubai. This exhilarating journey offers dune bashing, camel rides, and traditional Bedouin camp experiences under the star-lit desert sky.",
            "Our expert desert guides will lead you through heart-pounding 4x4 rides, followed by cultural activities including henna painting, falconry, and a delicious BBQ dinner. Perfect for those seeking a blend of adventure and cultural immersion."
        ],
        gallery: [
            images.portfolio3Gallery1,
            images.portfolio3Gallery2,
            images.portfolio3Gallery3,
            images.portfolio3Gallery4,
            images.portfolio3Gallery5,
            images.portfolio3Gallery6
        ],
        requirements: [
            "Comfortable clothing suitable for desert climate",
            "Willingness to engage in off-road dune activities",
            "Basic fitness level for camel riding and desert walks",
            "Open mind for cultural experiences in Bedouin camps"
        ],
        approach: [
            "Start with a thrilling 4x4 dune bashing experience",
            "Participate in camel trekking across desert trails",
            "Enjoy traditional desert camp activities and performances",
            "End the day with a serene sunset view and BBQ dinner"
        ],
        highlights: [
            "Adrenaline-filled dune bashing in the Dubai Desert",
            "Authentic camel rides and falconry demonstrations",
            "Traditional Emirati entertainment and cuisine",
            "Unforgettable desert sunset and star-gazing experience"
        ]
    },
    {
        id: 4,
        image: images.portfolio4,
        title: "Private Island Retreat",
        details: {
            date: "June 5, 2024",
            client: "Luxury Travelers",
            category: "Luxury Getaways",
            duration: "5 Days / 4 Nights",
            location: "Bahamas, Caribbean",
            cost: "$5,000 per person",
            tourGuide: "Isabella Monroe"
        },
        paragraphs: [
            "Escape to a world of luxury and serenity with our Private Island Retreat in the heart of the Caribbean. This exclusive getaway offers unparalleled privacy, pristine beaches, and personalized services designed for ultimate relaxation.",
            "From private beachside villas to gourmet dining and bespoke activities, every moment on this island is crafted to indulge your senses. Whether you're seeking a romantic escape or a secluded luxury adventure, this retreat promises an unforgettable experience."
        ],
        gallery: [
            images.portfolio4Gallery1,
            images.portfolio4Gallery2,
            images.portfolio4Gallery3,
            images.portfolio4Gallery4,
            images.portfolio4Gallery5,
            images.portfolio4Gallery6
        ],
        requirements: [
            "Preference for secluded and luxury travel experiences",
            "Interest in personalized services and private activities",
            "Desire for a tranquil, crowd-free environment",
            "Appreciation for high-end culinary and spa experiences"
        ],
        approach: [
            "Stay in lavish private villas with ocean views",
            "Indulge in bespoke dining and spa treatments",
            "Engage in curated island activities like snorkeling and yacht cruises",
            "Relax on exclusive private beaches with 24/7 concierge service"
        ],
        highlights: [
            "Ultimate privacy on an exclusive Caribbean island",
            "Luxury accommodations with top-tier amenities",
            "Personalized activities tailored to your preferences",
            "Unmatched relaxation and rejuvenation in a tropical paradise"
        ]
    },
    {
        id: 5,
        image: images.portfolio5,
        title: "Cultural Museum Tours",
        details: {
            date: "September 12, 2024",
            client: "Art & History Enthusiasts",
            category: "Cultural Experiences",
            duration: "3 Days",
            location: "Paris, France",
            cost: "$750 per person",
            tourGuide: "Émile Laurent"
        },
        paragraphs: [
            "Immerse yourself in a journey through time with our Cultural Museum Tours in Paris, the city of art and history. Visit world-renowned museums such as The Louvre, Musée d'Orsay, and Centre Pompidou, guided by experts who bring history to life.",
            "Perfect for art lovers and curious minds, this tour offers deep insights into iconic artworks, historical artifacts, and architectural marvels, ensuring an enriching and educational experience in the cultural heart of France."
        ],
        gallery: [
            images.portfolio5Gallery1,
            images.portfolio5Gallery2,
            images.portfolio5Gallery3,
            images.portfolio5Gallery4,
            images.portfolio5Gallery5,
            images.portfolio5Gallery6
        ],
        requirements: [
            "Interest in art, history, and museum explorations",
            "Comfortable footwear for extensive walking",
            "Basic knowledge of famous artworks (optional)",
            "Willingness to engage in guided educational tours"
        ],
        approach: [
            "Curated guided tours through iconic museums",
            "Interactive sessions with art historians and curators",
            "Ample free time for personal exploration and reflection",
            "Optional workshops on art appreciation and history"
        ],
        highlights: [
            "Exclusive access to iconic artworks and exhibitions",
            "Expert-guided storytelling enhancing your museum visit",
            "Opportunities for personal discovery in world-class museums",
            "Cultural immersion in the artistic heritage of Paris"
        ]
    },
    {
        id: 6,
        image: images.portfolio6,
        title: "Luxury Beach Resorts",
        details: {
            date: "December 1, 2024",
            client: "Holiday Vacationers",
            category: "Luxury Getaways",
            duration: "6 Days / 5 Nights",
            location: "Maldives",
            cost: "$3,500 per person",
            tourGuide: "Liam Foster"
        },
        paragraphs: [
            "Relax and rejuvenate at our Luxury Beach Resorts in the Maldives, where crystal-clear waters, white sandy beaches, and world-class amenities create a perfect tropical escape. Whether you’re seeking adventure or pure relaxation, this resort stay offers a seamless blend of both.",
            "Enjoy overwater villas, personalized spa treatments, underwater dining experiences, and thrilling water sports. Our team ensures every moment of your stay is catered to your comfort and luxury, making this the ultimate beach holiday experience."
        ],
        gallery: [
            images.portfolio6Gallery1,
            images.portfolio6Gallery2,
            images.portfolio6Gallery3,
            images.portfolio6Gallery4,
            images.portfolio6Gallery5,
            images.portfolio6Gallery6
        ],
        requirements: [
            "Preference for luxury beachfront accommodations",
            "Interest in water activities and relaxation",
            "Basic swimming skills for water-based adventures",
            "Desire for a premium, all-inclusive resort experience"
        ],
        approach: [
            "Stay in overwater or beachfront luxury villas",
            "Indulge in spa and wellness programs",
            "Participate in curated water sports and excursions",
            "Savor gourmet dining with oceanfront views"
        ],
        highlights: [
            "Breathtaking overwater villas with private pools",
            "World-class spa treatments and wellness activities",
            "Diverse water sports like snorkeling and jet-skiing",
            "Unforgettable sunsets and serene beachfront ambiance"
        ]
    }

];

export default portfolio;